<div class="lay-wrapper lay-wrapper--90">
  <app-welcome-banner [header]="'generic.main.hello' | translate" [title]="'generic.main.reportsText'" />

  <app-report-view-view />
</div>
